// @todo: Migrate to 'TextField' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {TextField} from '@wandb/weave/components/Form/TextField';
import React, {useMemo, useState} from 'react';

// Weave's Input component comment suggests not to use it if the default value is tied to state
// In this case, we need to be able to set the value based on the clone run selection
// eslint-disable-next-line wandb/no-deprecated-imports
import {FILE_KEY_DELIMITER, Property} from '../../utilTypes';
import PropertyHeader from './PropertyHeader';

type TextEntryProps = {
  property: Property;
  value: string | number;
  onChange: (event: any, context: any) => void;
};

export const TextEntry = ({property, value, onChange}: TextEntryProps) => {
  const [initialMount, setInitialMount] = useState(true);

  const isError = useMemo(() => {
    if (initialMount) {
      return false;
    }

    if (value == null || value === '') {
      return false;
    }

    if (typeof value === 'number') {
      if (property.type === 'integer' && !Number.isInteger(value)) {
        return true;
      }
      return (
        (property.minimum != null && value < property.minimum) ||
        (property.maximum != null && value > property.maximum) ||
        (property.exclusiveMinimum != null &&
          value <= property.exclusiveMinimum) ||
        (property.exclusiveMaximum != null &&
          value >= property.exclusiveMaximum)
      );
    } else if (typeof value === 'string') {
      if (property.type !== 'string') {
        return true;
      }
    }
    return false;
  }, [initialMount, value, property]);

  const id = (property.file ?? '') + FILE_KEY_DELIMITER + property.key;
  const type = property.type === 'string' ? 'text' : 'number';
  const valueStr = value == null ? '' : String(value);
  const onChangeValue = (value: string) => {
    setInitialMount(false);
    onChange(null as any, {id, value, type});
  };

  return (
    <div
      className="m-0 flex flex-col text-sm"
      key={property.key}
      data-test={property.key}>
      <PropertyHeader property={property} />
      <TextField
        id={id}
        type={type}
        value={valueStr}
        placeholder={property.placeholder ?? 'Enter a value'}
        errorState={isError}
        onChange={onChangeValue}
      />
      {isError && (
        <div className="mt-4 ml-2 text-xs text-red-450">Invalid value.</div>
      )}
    </div>
  );
};
